import { render, staticRenderFns } from "./PurchasersCreateModal.vue?vue&type=template&id=18c5d320&"
import script from "./PurchasersCreateModal.vue?vue&type=script&lang=js&"
export * from "./PurchasersCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports